export const UNDERWRITING_ISSUE = 'UNDERWRITING_ISSUE';
export const FIELD_VALIDATION = 'FIELD_VALIDATION';
export const GENERIC_VALIDATION = 'GENERIC_VALIDATION';

export const LEVEL_ERROR = 'LEVEL_ERROR';
export const LEVEL_WARN = 'LEVEL_WARN';

export default class DisplayableError {
    constructor({
        id, title,
        description, type,
        level, wizardSteps,
        isHidden
    }) {
        this.id = id;
        this.title = title;
        this.description = description;
        this.type = type;
        this.level = level;
        this.wizardSteps = wizardSteps;
        this.isHidden = isHidden;
    }
}